module.exports = __webpack_public_path__ + "img/sub_icon1.0f5d0050.svg";